import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight, CheckCircle, Loader2 } from 'lucide-react';
import { openBookingModal } from './BookingModal';

const API = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState(null); // 'loading' | 'success' | 'error' | 'already'
  const [subMsg, setSubMsg] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubStatus('loading');
    try {
      const res = await fetch(`${API}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json();
      if (res.ok) {
        setSubStatus('success');
        setSubMsg(data.message);
        setEmail('');
        setTimeout(() => setSubStatus(null), 5000);
      } else {
        setSubStatus('error');
        setSubMsg(data.detail || 'Something went wrong');
      }
    } catch {
      setSubStatus('error');
      setSubMsg('Network error. Please try again.');
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        {/* Newsletter Signup */}
        <div className="footer-newsletter" data-testid="footer-newsletter">
          <h4 className="footer-newsletter__title">Get AI tips for your business</h4>
          <p className="footer-newsletter__desc">Monthly insights on using AI to grow revenue, automate follow-ups, and close more deals.</p>
          {subStatus === 'success' ? (
            <div className="footer-newsletter__success" data-testid="newsletter-success-msg">
              <CheckCircle size={16} />
              <span>{subMsg}</span>
            </div>
          ) : (
            <form className="footer-newsletter__form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                className="footer-newsletter__input"
                data-testid="footer-newsletter-input"
              />
              <button
                type="submit"
                disabled={subStatus === 'loading'}
                className="footer-newsletter__btn"
                data-testid="footer-newsletter-submit"
              >
                {subStatus === 'loading' ? <Loader2 size={16} className="footer-newsletter__spin" /> : <ArrowRight size={16} />}
              </button>
            </form>
          )}
          {subStatus === 'error' && (
            <p className="footer-newsletter__error">{subMsg}</p>
          )}
        </div>

        {/* Existing footer content */}
        <div className="footer-row">
          <img 
            src="/logo-main.jpg" 
            alt="Skye AI" 
            className="footer-logo"
          />
          <ul className="footer-links">
            <li><Link to="/" className="footer-link">Home</Link></li>
            <li><Link to="/features" className="footer-link">Features</Link></li>
            <li><Link to="/how-it-works" className="footer-link">How It Works</Link></li>
            <li><Link to="/blog" className="footer-link">Blog</Link></li>
            <li><button onClick={openBookingModal} className="footer-link" style={{background:'none',border:'none',padding:0,cursor:'pointer'}}>Book a Growth Call</button></li>
          </ul>
          <div className="footer-contact">
            <a href="mailto:info@skyeai.io" className="footer-email">
              <Mail className="w-4 h-4" />
              info@skyeai.io
            </a>
          </div>
        </div>
        <p className="footer-copy">
          © {new Date().getFullYear()} Skye AI. AI Revenue Engine™ is a trademark of Skye AI. · <Link to="/privacy-policy" className="footer-link footer-link--small">Privacy Policy</Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
